import axios from 'axios';

import { store } from '../../index';

// Post off logs to the Chillipharm backend logging endpoint
export function logViaChillipharm(severity = 'info', logObject = {}) {
  axios.post(
    '/logs',
    {
      authenticity_token: store.getState().internal.authenticityToken,
      severity: severity, // e.g. 'info', 'warning', 'error'
      log: JSON.stringify({
        ...logObject,
        log_type: 'upload_error',
        upload_type: 'standard',
        region: '',
      }), // Endpoint specifically requires JSON.parse-able object
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    },
  );
}
